import script from "./VipTutorialCompnent.vue?vue&type=script&setup=true&lang=js"
export * from "./VipTutorialCompnent.vue?vue&type=script&setup=true&lang=js"

import "./VipTutorialCompnent.vue?vue&type=style&index=0&id=5753a85b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5753a85b"]])

export default __exports__